export function toTitleCase(str: string) {
	return str.replace(/[\W_]+/g, ' ').replace(/\b\w/g, (firstLetter) => firstLetter.toUpperCase())
}
